import React from 'react';

import { FeatureFlagged, FeatureGatedVariant } from '../../../feature-gates/feature-flagged';
import { FeatureGates } from '../../../feature-gates/feature-gates';
import { MessagePreviewItem } from '../../../messages/components/message-preview-item';
import { EmailMessage } from '../../../messages/legacy-components/email-message';
import { TextMessage } from '../../../messages/legacy-components/text-message';

import { PersonalizedByTeamEngineMessage } from './personalized-by-team-engine-message';

import { MESSAGE_TYPE } from '../../../util/message-types';
import { ConfirmableMessageText } from '../../utils/applicant-automation-display-utils';

export const ApplicantAutomationMessage = ({
  automation,
  orgName,
  hideStaticPersonalizedMessage,
}: {
  automation: ApplicantAutomation;
  orgName: string;
  hideStaticPersonalizedMessage?: boolean;
}) => {
  const messageBody = automation.isConfirmationRequired
    ? `${automation.template} ${ConfirmableMessageText}`
    : automation.template;

  if (automation.isUsingApplicationQuestions && !hideStaticPersonalizedMessage) {
    return <PersonalizedByTeamEngineMessage />;
  }

  return (
    <>
      <FeatureFlagged
        variant={FeatureGatedVariant.HIDE_ON_FLAG}
        flagName={FeatureGates.INTEGRATED_MESSAGING}
      >
        {automation.messageType === MESSAGE_TYPE.EMAIL ? (
          <EmailMessage
            className="u-width-100"
            senderName="Team Engine (automatically)"
            recipientName="The Applicant"
            subject={`Your application for ${orgName}`}
            messageBody={messageBody}
            isAutomated
          />
        ) : (
          <TextMessage
            className="u-width-100"
            senderName="Team Engine (automatically)"
            messageBody={messageBody}
            isAutomated
          />
        )}
      </FeatureFlagged>
      <FeatureFlagged
        variant={FeatureGatedVariant.SHOW_ON_FLAG}
        flagName={FeatureGates.INTEGRATED_MESSAGING}
      >
        <MessagePreviewItem
          messageType={automation.messageType}
          className="u-width-100"
          senderName="Team Engine (automatically)"
          recipientName="The Applicant"
          subject={`Your application for ${orgName}`}
          messageBody={messageBody}
          includesHTML
        />
      </FeatureFlagged>
    </>
  );
};
